import React from 'react'
import './LoadingAnimation.scss';
const LoadingAnimation = () => {
    return (
        <div className='loaderSpinner'/>
    )
}

export default LoadingAnimation
